jQuery(document).ready(function($) {
  let imagesPerClick = 9;
  let offset = 0;
  let loading = false;
  let allImages = [];

  const $section = $('.galerie-foto-elena');
  const jsonUrl = $section.data('json-url');

  $.ajax({
    url: jsonUrl,
    dataType: 'text',
    success: function(response) {
      const data = JSON.parse(response);

      //allImages = shuffleArray(data.images); 
      allImages = data.images;
      allImages.reverse();

      loadMoreImages();
    },
    error: function() {
      console.error("Eroare la încărcarea fișierului JSON.");
      $section.find('.load-more').hide();
    }
  });

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function loadMoreImages() {
    const nextImages = allImages.slice(offset, offset + imagesPerClick);
    offset += imagesPerClick;
    const lang = $("html").attr("lang");
    
    $.each(nextImages, function(i, img) {
      var link = img.src;
      var video = "";
      if(img.video!="")
      {
        link = img.video;
        video = `
          <div class="play-button">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.0343 12.6475L4.23375 19.6145C2.33427 20.736 0 19.2763 0 16.967V3.0329C0 0.723674 2.33427 -0.735974 4.23375 0.385476L16.0343 7.3525C17.9885 8.5065 17.9885 11.4935 16.0343 12.6475Z" fill="white"/>
            </svg>
          </div>
        `;
      }
      var title = img.title;
      var description = img.description;
      if(lang == "en")
      {
        if(img.description_en !="")
        {
          description = img.description_en;
        }
      }
      var btn_html = "";
      if(lang == "en")
      {
        if(img.link_en !="" && img.link_en !="#")
        {
          btn_html = `<a href="${img.link_en}" class="underline text-sm hover:text-gray-300">Buy now</a>`;
        }
      }
      else 
      {
        if(img.link !="" && img.link !="#")
        {
          btn_html = `<a href="${img.link}" class="underline text-sm hover:text-gray-300">Cumpără acum</a>`;
        }
      }


      const imgHtml = `
      <div class="galerie-item fade-in relative overflow-hidden group">
        <a href="${link}" data-fancybox="galerie">
          <img src="${img.src}" alt="${title}" class="w-full h-auto rounded-lg shadow object-cover" loading="lazy"/>
          ${video}
        </a>
        <div class="overlay absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition flex-col justify-center items-center text-center text-white p-4">
          <h3 class="text-lg font-semibold mb-1">${title}</h3>
          <p class="text-sm mb-2">${img.description}</p>
          ${btn_html}
        </div>
      </div>`;
      $section.find('.galerie-grid').append(imgHtml);
    });

    // Inițializează Fancybox pentru toate imaginile noi
    Fancybox.bind('[data-fancybox="galerie"]', {
      Thumbs: false,
      Toolbar: true,
      loop: true
    });

    if (offset >= allImages.length) {
      $section.find('.load-more').hide();
    }
  }

  $section.find('.load-more').on('click', function() {
    if (loading) return;
    loading = true;
    loadMoreImages();
    loading = false;
  });
});
